import { Component, inject, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { ServicesType } from '../../../types/services-type';
import { MenuActions } from '../../../states/menu_actions';

@Component({
  selector: 'ln-services-card',
  imports: [TranslocoPipe, LnImageFrameComponent],
  templateUrl: './services-card.component.html',
  styleUrl: './services-card.component.css',
})
export class ServicesCardComponent {
  @Input({ required: true }) imagePath!: string;
  @Input({ required: true }) name!: string;
  @Input({ required: true }) question!: string;
  @Input({ required: true }) answer!: string;
  @Input({ required: true }) serviceType!: ServicesType;
  menuAction = inject(MenuActions);

  navigateToServiceDetails(): void {
    this.menuAction.navigateToServiceDetails(this.serviceType);
  }
}
